const flats = [-65, -80, -60, -75, -55, -70, -50];
export default flats;
